import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://vsdkurupmcazzwrbeldh.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZzZGt1cnVwbWNhenp3cmJlbGRoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgwODA5NjUsImV4cCI6MjA4MzY1Njk2NX0.G2pM41KgndtQuFMFyyxn0Rbp9wJEUcn29IocT2pN-Lg'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})